export enum BarDataType {
  Booking = "booking",
  EdgeStart = "edge-start",
  EdgeEnd = "edge-end",
  Engagement = "engagement",
  Role = "role",
  Row = "row",
  Misalignment = "misalignment",
  Overbookings = "overbookings"
}

export const BOOKING_BAR_SELECTOR = `[data-type="${BarDataType.Booking}"]`;
export const BOOKING_ROW_KEY_ATTRIBUTE = "data-row-key";
export const BOOKING_ENTITY_ID_ATTRIBUTE = "data-entity-id";
export const BOOKING_ROW_SELECTOR = `[data-type="${BarDataType.Row}"][${BOOKING_ROW_KEY_ATTRIBUTE}]`;
export const BOOKING_DRAGGING_PLACEHOLDER_ATTRIBUTE = "data-booking-dragging-placeholder";
export const SPLIT_SEPARATOR_ATTRIBUTE = "data-split-separator";
export const BOOKING_TITLE_ATTRIBUTE = "data-booking-title";
export const BOOKING_START_ATTRIBUTE = "data-booking-start";
export const BOOKING_END_ATTRIBUTE = "data-booking-end";

export const getEdgeSelector = (type: BarDataType.EdgeStart | BarDataType.EdgeEnd, bookingId: number) =>
  `[data-type="${type}"][${BOOKING_ENTITY_ID_ATTRIBUTE}="${bookingId}"]`;
